import { faSquareCheck, faSquareXmark } from '@fortawesome/pro-duotone-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Typography } from '@mui/material';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAccessibility } from '../../../Store/contexts/AccessibilityContext';
import { sxDarkGreyBody } from '../../../assets/styles/CommonSxProps';
import DefaultButton from '../../../components/Accessibility/DefaultButton';
import PageTitle from '../../../components/Accessibility/PageTitle';
import VoltarButton from '../../../components/Accessibility/VoltarButton';
import WhiteContainer from '../../../components/Accessibility/WhiteContainer';
import LoadingApp from '../../../components/LoadingApp';
import ModalFeedBack from '../../../components/ModalFeedBack';
import { getConversasAbertas, getConversasConcluidas } from '../../../services/SaudeBemEstar/GestaoDeCronicosService';
import './styles.css';

const ChatComEquipeGC: React.FC = () => {

  const accessibility = useAccessibility();
  const navigate = useNavigate();
  const [modalFeedback, setModalFeedback] = useState<null | {
    icon?: 'error' | 'success' | 'warning', title?: string, textButton?: string, subTitle?: string,
    closeAction: () => void, showButtonModal: boolean, buttonAction?: () => void
  }>(null);

  const [loading, setLoading] = useState<boolean>(false);

  useEffect(() => {
    fetchConversas();
  }, []);

  const fetchConversas = async () => {
    setLoading(true);
    await fetchConversasAbertas();
    await fetchConversasConcluidas();
    setLoading(false);
  }

  const fetchConversasAbertas = async () => {
    const response = await getConversasAbertas();
    if (response?.status === 200) {
      const conversasAbertas = response.data;
      validateIfIsFirstAccess(conversasAbertas.length);
    } else {
      console.error(response);
      handleFetchConversationsError();
    }
  }

  const fetchConversasConcluidas = async () => {
    const response = await getConversasConcluidas();
    if (response?.status === 200) {
      const conversasConcluidas = response.data;
      validateIfIsFirstAccess(conversasConcluidas.length);
    } else {
      console.error(response);
      handleFetchConversationsError();
    }
  }

  const validateIfIsFirstAccess = (length: number) => {
    if (length > 0) {
      navigate(`/saudeBemEstar/gestaoDeCronicos/conversaEquipe/conversas`);
    }
  }

  const handleFetchConversationsError = () => {
    openModal('error', 'Erro', 'Ocorreu um erro ao buscar as conversas. Tente novamente mais tarde.',
      'Fechar', () => window.history.back(), () => window.history.back());
  }

  const openModal = (
    icon: 'success' | 'warning' | 'error', title: string, subTitle: string, textButton: string, closeAction: () => void, buttonAction: () => void
  ) => {
    setModalFeedback({
      icon,
      title,
      subTitle,
      textButton,
      showButtonModal: true,
      closeAction: closeAction,
      buttonAction: buttonAction
    });
  }

  return (
    <>
      {loading ?
        <LoadingApp showLoading={loading} text='Carregando...' />
        :
        <div className='chat-infos-container'>
          <PageTitle text='Chat com equipe' />

          <Typography
            sx={sxDarkGreyBody} style={accessibility.textStyleAccessibility} tabIndex={0}
          >
            Este é um canal de contato exclusivo com o Programa do Gestão de Crônicos.
          </Typography>

          <Typography
            sx={sxDarkGreyBody} style={accessibility.textStyleAccessibility} tabIndex={0}
            maxWidth={'580px'}
          >
            Para dúvidas relacionada a outros assuntos, que não sejam do Programa de Gestão de Crônicos, <a href="https://unime.acolhe.com.br" className='green-link'>acesse o Chat com a Camila</a>, nossa assistente virtual.
          </Typography>
          <WhiteContainer className='chat-tips' width={'100%'} maxWidth={'600px'}>
            <FontAwesomeIcon icon={faSquareCheck} className='fa-duotone-28x28' color='#00995D' />
            <Typography
              sx={sxDarkGreyBody} style={accessibility.textStyleAccessibility} tabIndex={0}
            >
              <b>Ideal para:</b><br />
              Tirar dúvidas sobre o Programa e seu cronograma de atendimento.
            </Typography>
          </WhiteContainer>
          <WhiteContainer className='chat-tips' width={'100%'} maxWidth={'600px'}>
            <FontAwesomeIcon icon={faSquareXmark} className='fa-duotone-28x28' color='#D84141' />
            <Typography
              sx={sxDarkGreyBody} style={accessibility.textStyleAccessibility} tabIndex={0}

            >
              <b>Não utilizar para:</b><br />
              Tratar sobre assuntos que não pertencem ao Programa, como faturas ou dúvidas gerais em relação à Unimed.
            </Typography>
          </WhiteContainer>
          <DefaultButton text='Iniciar nova conversa' onClick={() => navigate('/saudeBemEstar/gestaoDeCronicos/conversaEquipe/conversas/nova')} />
          <VoltarButton text='Voltar' onClick={() => window.history.back()} />
        </div>
      }
      <ModalFeedBack
        showModal={!!modalFeedback}
        handleShowModal={modalFeedback?.closeAction}
        title={modalFeedback?.title as string}
        subTitle={modalFeedback?.subTitle as string}
        icon={modalFeedback?.icon as 'success' | 'error' | 'warning'}
        showButtonModal={modalFeedback?.showButtonModal}
        textButton={modalFeedback?.textButton as string}
        handleButtonModal={modalFeedback?.buttonAction}
      />
    </>
  )
}

export default ChatComEquipeGC;